import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_ALL_STATES,
  getAllStatesFailure,
  getAllStatesSuccess,
  GET_ALL_DEALERS,
  getAllDealersFailure,
  getAllDealersSuccess,
  GET_ALL_DISTRICTS,
  getAllDistrictsFailure,
  getAllDistrictsSuccess,
  GET_ALL_TEHSILS,
  getAllTehsilsFailure,
  getAllTehsilsSuccess,
} from "../actions/dealer-action-types";
import { showLoader, hideLoader } from "../actions/app-action-types";
import {
  GetAllDealers,
  GetAllState,
  GetAllDistrict,
  GetAllTehsil,
} from "../api";

// Get All States.
function* getAllStates() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllState);
    yield put(getAllStatesSuccess(result?.data ?? []));
  } catch (error) {
    yield put(getAllStatesFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All Districts.
function* getAllDistricts() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllDistrict);
    yield put(getAllDistrictsSuccess(result?.data ?? []));
  } catch (error) {
    yield put(getAllDistrictsFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All States.
function* getAllTehsils() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllTehsil);
    yield put(getAllTehsilsSuccess(result?.data ?? []));
  } catch (error) {
    yield put(getAllTehsilsFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All Dealers.
function* getAllDealers() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllDealers);
    yield put(getAllDealersSuccess(result?.data ?? []));
  } catch (error) {
    yield put(getAllDealersFailure({ error }));
  }
  yield put(hideLoader());
}

// Combine all dealers action into one saga function.
function* Dealers() {
  yield all([
    takeLatest(GET_ALL_STATES, getAllStates),
    takeLatest(GET_ALL_DISTRICTS, getAllDistricts),
    takeLatest(GET_ALL_TEHSILS, getAllTehsils),
    takeLatest(GET_ALL_DEALERS, getAllDealers),
  ]);
}

export default Dealers;
